module.exports = date => {
	return date ? date.toString('yyyy-MM-dd') : '';
}
